import {FieldTimeOutlined, MessageOutlined, SlidersOutlined, SmileOutlined} from "@ant-design/icons";
import {Steps} from "antd";
import {StepsProps} from "../../stepsProcess/StepsProcess";

interface StepsTracker {
    step: number;
    stepsDone: number;
    setStep: (newVal: number) => void;
    steps: StepsProps[];
    showProgressCircles?: boolean;
}

const StepsTracker = ({ showProgressCircles = true, steps, step, stepsDone, setStep }: StepsTracker) => {
    const getStepStatus = (stepNum: number) => {
        if(step > stepNum) return 'finish';
        if(step === stepNum) return 'process';
        return 'wait';
    }

    return (
        <Steps percent={showProgressCircles ? step / steps.length * 100 : undefined}
            items={steps.map((step, index) => ({
                ...step,
                status: getStepStatus(index+1),
                // onClick: () => stepsDone > index ? setStep(index+1) : null,
            }))}
        />
    );
}

export default StepsTracker;